<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="user-check"
			class="svg-inline--fa fa-user-check"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512"
		>
			<path
				class="light"
				fill="currentColor"
				d="M274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512H413.3C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336H274.7C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480zM224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM635.3 154c-6.25-6.25-16.38-6.25-22.62 0l-95.34 95.36l-42.03-42.02c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62l53.34 53.33C509.2 286.4 513.3 288 517.3 288s8.188-1.562 11.31-4.688l106.7-106.7C641.6 170.4 641.6 160.3 635.3 154z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'UserCheckIcon',
	components: { Icon },
	props,
}
</script>
